/**
 * Pure Scentum — hero slider.
 * Works for every [data-ps-hero] section on the page (theme editor can add
 * more than one). Supports prev/next buttons, dot navigation, and left/right
 * arrow keys while the slider is on screen.
 */
(function () {
  function initHero(root) {
    if (root.__psHeroInit) return;
    root.__psHeroInit = true;

    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-ps-hero-slide]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-ps-hero-dot]'));
    var prevBtn = root.querySelector('[data-ps-hero-prev]');
    var nextBtn = root.querySelector('[data-ps-hero-next]');
    if (slides.length < 2) return; // nothing to slide

    var current = 0;
    var autoplayMs = parseInt(root.getAttribute('data-ps-hero-autoplay') || '0', 10);
    var timer = null;

    function go(index) {
      var n = slides.length;
      current = ((index % n) + n) % n;
      slides.forEach(function (slide, i) {
        var on = i === current;
        slide.classList.toggle('is-active', on);
        slide.style.opacity = on ? '1' : '0';
        slide.style.pointerEvents = on ? 'auto' : 'none';
        if (on) slide.removeAttribute('aria-hidden');
        else slide.setAttribute('aria-hidden', 'true');
      });
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === current);
        dot.setAttribute('aria-selected', i === current ? 'true' : 'false');
      });
      restartAutoplay();
    }

    function restartAutoplay() {
      if (!autoplayMs) return;
      clearTimeout(timer);
      timer = setTimeout(function () { go(current + 1); }, autoplayMs);
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { go(current - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { go(current + 1); });
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { go(i); });
    });

    // Keyboard navigation, only while the slider is in (or near) view and
    // the user isn't typing in a field.
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
      var target = e.target;
      if (target && /^(INPUT|TEXTAREA|SELECT)$/.test(target.tagName)) return;
      var rect = root.getBoundingClientRect();
      if (rect.bottom < 80 || rect.top > window.innerHeight - 80) return;
      go(current + (e.key === 'ArrowRight' ? 1 : -1));
    });

    // Pause autoplay while a pointer is over the slider.
    root.addEventListener('mouseenter', function () { clearTimeout(timer); });
    root.addEventListener('mouseleave', restartAutoplay);

    go(0);
  }

  function initAll() {
    document.querySelectorAll('[data-ps-hero]').forEach(initHero);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('[data-ps-hero]');
    if (section) initHero(section);
  });
})();
